import React from 'react';

const BranchComparison = ({ data }) => {
    if (!data || data.length === 0) return null;

    return (
        <div className="card shadow-sm h-100">
            <div className="card-body">
                <h6 className="card-title mb-3">Branch Metric Comparison</h6>
                <div className="table-responsive">
                    <table className="table table-sm table-bordered mb-0">
                        <thead className="table-light">
                            <tr>
                                <th>Location</th>
                                <th className="text-end">Orders</th>
                                <th className="text-end">Revenue</th>
                                <th className="text-end">Discounts</th>
                                <th className="text-end">Pieces</th>
                                <th className="text-end">Deliveries</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((loc, i) => (
                                <tr key={i}>
                                    <td>{loc.location_name}</td>
                                    <td className="text-end">{loc.orders}</td>
                                    <td className="text-end">{loc.revenue?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</td>
                                    <td className="text-end">{loc.discounts?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</td>
                                    <td className="text-end">{loc.pieces_produced?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</td>
                                    <td className="text-end">{loc.deliveries}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default BranchComparison;
